<ng-container *ngIf="isRunning === false; else loading">
  Export
</ng-container>
<ng-template #loading>
  <img class="loader" src="assets/img/loader-primary.svg" />
</ng-template>
